import { render, staticRenderFns } from "./UChemCardWithDetails.vue?vue&type=template&id=b1b607fa"
import script from "./UChemCardWithDetails.vue?vue&type=script&lang=js"
export * from "./UChemCardWithDetails.vue?vue&type=script&lang=js"
import style0 from "./UChemCardWithDetails.vue?vue&type=style&index=0&id=b1b607fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports